import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import {
    CloseApplicationType,
    applicationTypeLabels,
} from "@common/types/closeApplicationType";
import { ClientsWorkOverviewRow } from "../clientsWorkOverviewViewConfig";
import { EMPTY_CELL_VALUE } from "./emptyCellValue";

export const WorkApplicationTypeCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ClientsWorkOverviewRow,
        CloseApplicationType
    >) => {
        if (row.original.rowType !== "work") {
            return EMPTY_CELL_VALUE;
        }

        const { applicationType } = row.original;

        return applicationTypeLabels[applicationType];
    },
);

WorkApplicationTypeCell.displayName = "WorkApplicationTypeCell";
